(function ($, Drupal, once) {
  Drupal.behaviors.myCustomAjax = {
    attach: function (context, settings) {
      once('myCustomAjax', '.artist-list-items .thumb-container .years a', context).forEach(function (element) {
        // Your code here
        $(element).click(function (e) {
            e.preventDefault();
            var year_selected = $(this).html();
            var localeCode = $("#country_code").val();
            
            if (localeCode != "") {
              localeCode = "/" + localeCode;
            }
            
            
            $.ajax({
                url: localeCode + '/artist_list_content/' + year_selected + '/' + localeCode, // Replace with the actual AJAX path of your View
                type: 'GET',
                dataType: 'html',
                success: function (response) {
                  // Update the View content with the AJAX response
                  
                  console.log(response);
                  $(".artist-hero-header").find('.basic-content').find('.content').html(year_selected);
                  $('.block-gf-themes').html(response);
                  
                  $([document.documentElement, document.body]).animate({
              			scrollTop: $(".artist-hero-header .basic-content").offset().top
              		}, 1000);
                },
                error: function (xhr, status, message) {
                  console.error('Error filtering View content:', message);
                }
            });
            
            return false;
          });
      });
      
      // $('.thumb-container a', context).once('myCustomAjax').click(function (e) {
      //     e.preventDefault();
      //   // Make AJAX request.
      //   // $.ajax({
      //   //   url: '/my-custom-ajax-endpoint', // Custom route URL.
      //   //   type: 'GET',
      //   //   dataType: 'html',
      //   //   success: function (response) {
      //   //     // Replace the content of the block with the AJAX response.
      //   //     $('#my-ajax-block').html(response);
      //   //   },
      //   //   error: function (xhr, status, message) {
      //   //     console.error('Error:', message);
      //   //   }
      //   // });
      //   var year_selected = $(this).html();
        
      //   $.ajax({
      //       url: '/artist_list_content/' + year_selected, // Replace with the actual AJAX path of your View
      //       type: 'GET',
      //       dataType: 'html',
      //       success: function (response) {
      //         // Update the View content with the AJAX response
              
      //         console.log(response);
      //         $(".artist-hero-header").find('.basic-content').find('.content').html(year_selected);
      //         $('.block-gf-themes').html(response);
              
      //         $([document.documentElement, document.body]).animate({
      //     			scrollTop: $(".artist-hero-header .basic-content").offset().top
      //     		}, 1000);
      //       },
      //       error: function (xhr, status, message) {
      //         console.error('Error filtering View content:', message);
      //       }
      //   });
        
      //   return false;
      // });
    }
  };
  
  
  
  // const image = document.getElementById('zoomImage');
  // const container = document.getElementById('imageContainer');
  $(document).ready(function() {
    
  if ($(".artists-page").length) {
    const previewContainer = document.getElementsByClassName('gallery-item-preview');
    const containers = previewContainer[0].getElementsByClassName('item_wrapper');
    var curImage = null;
    let event_listener_local;

   function closeDialog()
   {
      $(".dialog-preview-gallery").addClass('hidden');
      $(".gallery-item-preview .bg-image").removeClass("zoom" + count);
      count = 0;
      $("body").removeClass('overflow-none');

      let big_picture_video=$('.gallery-item-preview .item_video');
      let big_picture_audio=$('.gallery-item-preview .item_audio');

      big_picture_video.trigger('pause');
      big_picture_audio.trigger('pause');

      big_picture_video.find('source').attr('src','');
      big_picture_audio.find('source').attr('src','');
      if(event_listener_local) {
        event_listener_local.removeEventListener('dragstart',{});
        event_listener_local.removeEventListener('mousedown',{});
        event_listener_local.removeEventListener('mouseup',{});
        event_listener_local.removeEventListener('mousemove',{});
      }
   }
   
    var count = 0;
    var zoomlimit = 13;
    $(".dialog-backdrop,.dialog-close").on('click', function() {
      //if ($(event.target).attr('class') != "preview-image") {
        closeDialog();
      //}
      return false;
    });
    $(".bg-image-elem").on('click', function() {
      // console.log('CLICKED ON IMG')
      let parent = $(this).parent().parent();
      //parent=parent[0];
      // console.log(parent,parent.find('.item_video').attr('class'),parent.find('.item_video').length);
      let media_target;
      let media_type = 0; // 0 = none, 1 =audio, 2 = video
      if(parent.find('.item_audio').length>0) media_type=1;
      else if(parent.find('.item_video').length>0) media_type=2;
  
      // console.log('media_type',media_type)
  
      if(media_type!=0) {
        if(media_type==1) media_target=parent.find('.item_audio');
        else media_target=parent.find('.item_video');
      }
      
      let big_picture_controls=$('.gallery-item-preview').parent().find('.controls');
      let big_picture_picture=$('.gallery-item-preview .bg-image');
      let big_picture_video=$('.gallery-item-preview .item_video');
      let big_picture_audio=$('.gallery-item-preview .item_audio');

      $(".dialog-preview-gallery").removeClass('hidden');
      $("body").addClass('overflow-none');

      big_picture_video.hide();
      big_picture_audio.hide();

      if(media_type==2) {
        // VIDEO PROVIDED IS A VIDEO - HIDE PICTURE, CHANGE VIDEO SOURCE, HIDE CONTROLS AND PREVENT EXIT FROM SCOPE

        big_picture_video.find('source').attr('src',media_target.attr('data-src'));

        big_picture_controls.hide();
        big_picture_picture.hide();

        big_picture_video.prop('currentTime',0)
        big_picture_video.delay(200).fadeIn(500); //SHOW VIDEO
        big_picture_video.trigger('load');
        return false;
      }else if(media_type==1) {
        // AUDIO PROVIDED - KEEP PICTURE
        
        big_picture_audio.find('source').attr('src',media_target.attr('data-src'));
        big_picture_audio.prop('currentTime',0)
        big_picture_audio.trigger('load')
        big_picture_audio.show();
      }
      big_picture_video.find('source').attr('src','');

      big_picture_picture.show();
      big_picture_controls.show();


      var imgsrc = $(this).attr('src');
      curImage = containers[0].querySelectorAll('img'); 
      curImage = curImage[0];
      curImage.src = imgsrc;
      
      if (curImage.naturalWidth > curImage.naturalHeight) {
        curImage.classList.remove('portrait');
        curImage.classList.add('landscape');
      } else {
        curImage.classList.remove('landscape');
        curImage.classList.add('portrait');
      }
      
      big_picture_picture.removeClass("zoom" + count);
      count = 0;
      
      // Assign dragging to the newly opened image and it's container
      var startX, startY, scrollX, scrollY;
      event_listener_local=curImage;
      curImage.addEventListener('dragstart', function(event) {
          // Prevent the default action to stop the browser from dragging the image as a source
          event.preventDefault();
          
          // Store initial mouse position and scroll position
          startX = event.clientX;
          startY = event.clientY;
          scrollX = containers[0].scrollLeft;
          scrollY = containers[0].scrollTop;
      });
      
      curImage.addEventListener('mousedown', function(event) {
          // Store initial mouse position and scroll position on mousedown
          startX = event.clientX;
          startY = event.clientY;
          scrollX = containers[0].scrollLeft;
          scrollY = containers[0].scrollTop;
      
          // Add a temporary mousemove event to simulate drag behavior
          function onMouseMove(event) {
              // Calculate the distance moved by the mouse
              var deltaX = event.clientX - startX;
              var deltaY = event.clientY - startY;
      
              // Update the scrollLeft and scrollTop of the container
              containers[0].scrollLeft = scrollX - deltaX;
              containers[0].scrollTop = scrollY - deltaY;
          }
      
          // Add event listeners for mousemove and mouseup
          curImage.addEventListener('mousemove', onMouseMove);
          curImage.addEventListener('mouseup', function onMouseUp() {
              curImage.removeEventListener('mousemove', onMouseMove);
              curImage.removeEventListener('mouseup', onMouseUp);
          });
      });
      
      return false;
    });
    
    $(".dialog-close").on('click', function(event) {
      
      closeDialog();
      return false;
    })
    $(".controls-item-add").on('click', function(evt) {
        evt.preventDefault();
        count++;
        
        if (count > zoomlimit) {
          count = zoomlimit;
          var prevClass = "zoom" + (count - 1);
          $(".gallery-item-preview .bg-image").removeClass(prevClass);
          return false;
        }
        var prevClass = "zoom" + (count - 1);
        var nextClass = "zoom" + (count);
        
        $(".gallery-item-preview .bg-image").removeClass(prevClass).addClass(nextClass);
        return false;
    });
    
    $(".controls-item-minus").on('click', function(evt) {
        evt.preventDefault();
        count--;
        
        if (count < 0) {
          count = 0;
          var prevClass = "zoom" + (count + 1);
          $(".gallery-item-preview .bg-image").removeClass(prevClass);
          return false;
        }
        var prevClass = "zoom" + (count + 1);
        var nextClass = "zoom" + (count);
        $(".gallery-item-preview .bg-image").removeClass(prevClass).addClass(nextClass);
        return false;
    });
    }
  });
  
})(jQuery, Drupal, once);